import { useEffect, useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import LogoutIcon from '@mui/icons-material/Logout';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { clearStorage, getStorage } from '../utils/localStorage';

const drawerWidth = 240;

function Dashboard(props) {
    const navigate = useNavigate();
    const { window } = props;
    const [mobileOpen, setMobileOpen] = useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    useEffect(() => {
        const isLogged = getStorage('isLogged');
        if (!isLogged) {
            navigate('/');
        }
    }, [])

    const handleLogout = () => {
        clearStorage();
    }

    const drawer = (
        <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
            <Typography variant="h6" sx={{ my: 2 }}>
                Bethel
            </Typography>
            <Divider />
            <List>
                <Link to='/dashboard/users'>
                    <ListItem key='Usuarios' disablePadding>
                        <ListItemButton sx={{ textAlign: 'center' }}>
                            <ListItemText primary='Usuarios' />
                        </ListItemButton>
                    </ListItem>
                </Link>
                <Link to='/dashboard/notifications'>
                    <ListItem key='Notificaciones' disablePadding>
                        <ListItemButton sx={{ textAlign: 'center' }}>
                            <ListItemText primary='Notificaciones' />
                        </ListItemButton>
                    </ListItem>
                </Link>
                <Link to='/dashboard/promotions'>
                    <ListItem key='Promociones' disablePadding>
                        <ListItemButton sx={{ textAlign: 'center' }}>
                            <ListItemText primary='Promociones' />
                        </ListItemButton>
                    </ListItem>
                </Link>
            </List>
        </Box>
    );

    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <Box sx={{ display: 'flex' }}>
            <AppBar component="nav" color="info" enableColorOnDark>
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ mr: 2, display: { sm: 'none' } }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography
                        variant="h6"
                        component="div"
                        sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}
                    >
                        Bethel
                    </Typography>
                    <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                        <Link to='/dashboard/users'>
                            <Button sx={{ color: '#fff' }}>
                                Usuarios
                            </Button>
                        </Link>
                        <Link to='/dashboard/notifications'>
                            <Button sx={{ color: '#fff' }}>
                                Notificaciones
                            </Button>
                        </Link>
                        <Link to='/dashboard/promotions'>
                            <Button sx={{ color: '#fff' }}>
                                Promociones
                            </Button>
                        </Link>
                        <Link to='/'>
                            <Button sx={{ color: 'white' }} onClick={handleLogout}>
                                <LogoutIcon />
                            </Button>
                        </Link>
                    </Box>
                </Toolbar>
            </AppBar>
            <Box component="nav">
                <Drawer
                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        display: { xs: 'block', sm: 'none' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}
                >
                    {drawer}
                </Drawer>
            </Box>
            <Box component="main" sx={{ p: 3 }} style={{ flex: 1 }}>
                <Toolbar />
                <Outlet />
            </Box>
        </Box>
    );
}

export default Dashboard;
